import { AlertTriangle, RefreshCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function DashboardError({ onRetry, title = "Unable to load dashboard data", section = "dashboard analytics" }) {
    return (
        <div className="flex flex-col items-center justify-center h-[70vh] text-center px-6">
            <div className="w-14 h-14 rounded-full bg-red-100 flex items-center justify-center mb-4">
                <AlertTriangle className="w-7 h-7 text-red-500" />
            </div>

            <h2 className="text-xl font-semibold mb-2">
                {title}
            </h2>

            <p className="text-muted-foreground max-w-md mb-6">
                {`Something went wrong while fetching your ${section}.
                Please try refreshing the page or try again in a few moments.`}
            </p>

            {/* <Button onClick={onRetry} className="gap-2">
                <RefreshCcw className="w-4 h-4" />
                Retry
            </Button> */}
        </div>
    );
}